// Environment configuration for the React app
export const config = {
  // API Configurations
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'NO_BASE_URL_SET',
    environment: process.env.REACT_APP_ENVIRONMENT || 'NO_ENVIRONMENT_SET'

};

// Debug logging (will be removed in production build)
if (process.env.NODE_ENV !== 'production') {
  console.log('🔧 Environment Config:', {
    baseUrl: config.baseUrl,
    environment: config.environment,
    allEnvVars: Object.keys(process.env).filter(key => key.startsWith('REACT_APP_'))
  });
}

export default config;
